import { ENV } from 'utils/env';
import { rest } from 'msw';
import { weborderingConfigurationFixtureFactory } from '../factories/weborderingConfiguration';
import { menuFixtureFactory } from '../factories/menu';
import { orderCreatedFixtureFactory, orderVerifiedFixtureFactory } from '../factories/order';
import { orderMock } from '../factories/order/mock';
import { consumptionModeFixtureFactory } from '../factories/consumptionMode';

export const handlers = [
    rest.get(`${ENV.API_URL}/brands/webordering-configuration/:brandHash`, (req, res, ctx) => {
        if (
            !req.params.brandHash ||
            ['error', 'no-brand'].includes(req.params.brandHash as string)
        ) {
            return res(ctx.status(400), ctx.json({ message: `Unknown brand` }));
        }
        return res(
            ctx.json({
                data: weborderingConfigurationFixtureFactory(),
            }),
        );
    }),
    rest.get(`${ENV.API_URL}/menus/:menuId/hash_map`, (req, res, ctx) => {
        if (!req.params.menuId || ['no-menu'].includes(req.params.menuId as string)) {
            return res(ctx.status(400), ctx.json({ message: `Unknown menu` }));
        }
        return res(ctx.status(200), ctx.json({ data: menuFixtureFactory() }));
    }),
    rest.get(`${ENV.API_URL}/consumption_modes`, (req, res, ctx) => {
        return res(ctx.status(200), ctx.json({ data: [consumptionModeFixtureFactory()] }));
    }),
    rest.post(`${ENV.API_URL}/orders/preview`, async (req, res, ctx) => {
        const body = await req.json();

        return res(
            ctx.status(200),
            ctx.json({
                data: orderVerifiedFixtureFactory(body.restaurantId === 1 ? body : orderMock),
            }),
        );
    }),
    rest.post(`${ENV.API_URL}/orders`, async (req, res, ctx) => {
        const body = await req.json();

        return res(
            ctx.status(200),
            ctx.json({
                data: orderCreatedFixtureFactory(body.restaurantId === 1 ? body : orderMock),
            }),
        );
    }),

    rest.get('/*', (req) => {
        return req.passthrough();
    }),

    rest.post('https://*.ingest.sentry.io/*', (req, res, ctx) => {
        return res(ctx.json(null));
    }),

    rest.post(`${ENV.ELASTIC_APM_SERVER_URL}/*`, (req, res, ctx) => {
        return res(ctx.json(null));
    }),
];
